import { Environment } from "../utils/Environment";

const apiUrl = Environment.getApiUrl();

export async function createUser(
    username: string,
    password: string,
    client_id: string,
    client_name: string,
    email: string
): Promise<any> {
    const response = await fetch(`${apiUrl}/create-user`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password, client_name, client_id, email }),
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || "Failed to create user");
    }
    return await response.json();
}